import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  id: 0,
  utilityId: 1,
  applicationTypeId: 2,
  applicant: {
    id: 0,
    applicantTypeId: "",
    applicantName: "",
    panNumber: "",
    gstNumber: "",
    occupancyTypeId: "",
    addressType: "",
    correspondenceAddress: "",
    city: "",
    pinCode: "",
    email: "",
    mobileNumber: "",
    landLine: "",
    alternateEmail: "",
    alternateMobileNumber: "",
    eBillConfirmation: false,
  },
  authorizedPerson: {
    id: 0,
    salutation: "",
    firstName: "",
    middleName: "",
    lastName: "",
    // gender: "",
    // ageCategory: "",
    designation: "",
    email: "",
    mobileNumber: "",
    landLine: "",
  },
  connectionLoad: {
    id: 0,
    powerRequirementUnit: "",
    loadDetails: "",
    supplyVoltage: "",
    supplyVoltageUnit: "",
    powerRequirement: "",
    timeShift: "",
    tention: "",
    expectedConnectionStartDate: "",
    expectedConnectionEndDate: "",
  },
  utilityAddress: {
    id: 0,
    premiseTypeId: "",
    premiseUsagePurpose: "",
    premisesAreaId: "",
    zoneId: "",
    blockId: "",
    roadId: "",
    buildingId: "",
    floors: [],
    unitName: "",
    nearestLandmark: "",
    isBPL: "",
    // isRural: "",
    otherZone: "",
    otherBlock: "",
    otherBuilding: "",
    otherRoad: "",
  },
  declaration: {
    declarationId: 0,
    consumerDuesOutstanding: "",
    premisesDuesOutstanding: "",
    firmDuesOutstanding: "",
  },
  extraValues: {
    requiredDocumentsCount: 0,
    proofOfOwnershipTypes: [],
  },
  proofOfOwnershipDescription: "",
  documents: [],
  isDraft: true,
};

const temporaryConnectionSlice = createSlice({
  name: "temporaryConnectionFormData",
  initialState,
  reducers: {
    setValues(_, action) {
      return action.payload;
    },
    resetValues() {
      return initialState;
    },
  },
});

export const { setValues, resetValues } = temporaryConnectionSlice.actions;

export default temporaryConnectionSlice.reducer;
